import React, { useState, useEffect, useContext } from "react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Autocomplete, {
	createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";
import { listWhatsapps } from "../../services/whatsapp.api";
import { createTicket } from "../../services/tickets.api";
import { listContacts } from "../../services/contacts.api";
import { findAllQueues } from "../../services/queue.api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactModal from "../ContactModal";
import ConfirmationModal from "../ConfirmationModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

import { Grid, MenuItem, Select } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
//import ShowTicketOpen from "../ShowTicketOpenModal";

const filter = createFilterOptions({
  trim: true,
});

const NewTicketModal = ({ modalOpen, onClose, initialContact }) => {
  const [options, setOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [newContact, setNewContact] = useState({});
  const [whatsapps, setWhatsapps] = useState([]);
  const [queues, setQueues] = useState([]); // ✅ NUEVO: Estado para almacenar queues cargadas desde API
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [confirmUpdateOpen, setConfirmUpdateOpen] = useState(false); // ✅ AGREGADO: Modal de confirmación
  const [errorModalOpen, setErrorModalOpen] = useState(false); // ✅ AGREGADO: Modal de error (solo para errores del backend)
  const [errorMessage, setErrorMessage] = useState(""); // ✅ AGREGADO: Mensaje de error (solo para errores del backend)
  // ✅ NUEVO: Estados para errores de validación inline
  const [queueError, setQueueError] = useState("");
  const [whatsappError, setWhatsappError] = useState("");
  const [contactError, setContactError] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [existingTicket, setExistingTicket] = useState(null); // ✅ AGREGADO: Ticket existente para actualizar (reservado para futuras mejoras)
  const [pendingTicketData, setPendingTicketData] = useState(null); // ✅ AGREGADO: Datos del ticket pendiente
  const { user } = useContext(AuthContext);
  const { companyId, whatsappId } = user;




  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact]);
      setSelectedContact(initialContact);
    } else if (modalOpen) {
      // ✅ CORREGIR: Si no hay initialContact y el modal está abierto, limpiar selectedContact
      setSelectedContact(null);
    }
  }, [initialContact, modalOpen]);

  useEffect(() => {
    if (!modalOpen) {
      // ✅ CORREGIR: Limpiar estados cuando el modal se cierra
      setSearchParam("");
      setSelectedContact(null);
      setSelectedQueue("");
      setSelectedWhatsapp("");
      setErrorModalOpen(false);
      setErrorMessage("");
      setConfirmUpdateOpen(false);
      setExistingTicket(null);
      setPendingTicketData(null);
      // ✅ Limpiar errores inline
      setQueueError("");
      setWhatsappError("");
      setContactError("");
      return;
    }
    
    // ✅ CORREGIR: Limpiar estados ANTES de cargar datos cuando se abre el modal
    // PERO mantener selectedContact si hay initialContact
    setSearchParam("");
    if (!initialContact) {
      setSelectedContact(null);
    }
    setSelectedQueue("");
    setSelectedWhatsapp("");
    setErrorModalOpen(false);
    setErrorMessage("");
    setConfirmUpdateOpen(false);
    setExistingTicket(null);
    setPendingTicketData(null);
    // ✅ Limpiar errores inline
    setQueueError("");
    setWhatsappError("");
    setContactError("");
    
    let isMounted = true;
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchData = async () => {
        try {
          // ✅ Cargar whatsapps
          const whatsappResponse = await listWhatsapps({ companyId, session: 0 });
          if (isMounted) {
            setWhatsapps(whatsappResponse.data);
          }

          // ✅ Cargar queues desde la API (no solo del contexto)
          const queueResponse = await findAllQueues();
          if (isMounted) {
            setQueues(queueResponse.data);
          }

          // ✅ Configurar valores por defecto SOLO si no hay initialContact
          if (isMounted && !initialContact) {
            if (whatsappId !== null && whatsappId !== undefined) {
              setSelectedWhatsapp(whatsappId);
            }

            // ✅ Usar queues cargadas desde API o fallback a user.queues
            const availableQueues = queueResponse?.data || user.queues || [];
            if (availableQueues.length === 1) {
              setSelectedQueue(availableQueues[0].id);
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          // ✅ Fallback: usar user.queues si falla la carga desde API
          if (isMounted && user.queues && user.queues.length > 0) {
            setQueues(user.queues);
            if (user.queues.length === 1 && !initialContact) {
              setSelectedQueue(user.queues[0].id);
            }
          }
        } finally {
          if (isMounted) {
            setLoading(false);
          }
        }
      };

      fetchData();
    }, 500);
    
    return () => {
      isMounted = false;
      clearTimeout(delayDebounceFn);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, companyId, whatsappId]); // ✅ user.queues omitido intencionalmente para evitar bucles infinitos

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    
    let isMounted = true;
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await listContacts({ searchParam });
          if (isMounted) {
            setOptions(data.contacts);
            setLoading(false);
          }
        } catch (err) {
          if (isMounted) {
            setLoading(false);
            toastError(err);
          }
        }
      };
      fetchContacts();
    }, 500);
    
    return () => {
      isMounted = false;
      clearTimeout(delayDebounceFn);
    };
  }, [searchParam, modalOpen]);

  // const IconChannel = (channel) => {
  //   switch (channel) {
  //     case "facebook":
  //       return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
  //     case "instagram":
  //       return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
  //     case "whatsapp":
  //       return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />
  //     default:
  //       return "error";
  //   }
  // };

  const handleClose = () => {
    // ✅ CORREGIR: Limpiar TODOS los estados al cerrar el modal
    setSearchParam("");
    setSelectedContact(null);
    setSelectedQueue("");
    setSelectedWhatsapp("");
    setErrorModalOpen(false);
    setErrorMessage("");
    setConfirmUpdateOpen(false);
    setExistingTicket(null);
    setPendingTicketData(null);
    onClose();
  };



  const handleSaveTicket = async (contactId, confirmUpdate = false) => {
    // ✅ Limpiar errores previos
    setQueueError("");
    setWhatsappError("");
    setContactError("");
    
    let hasErrors = false;
    
    // ✅ VALIDACIÓN 1: Verificar que contactId esté presente
    if (!contactId) {
      setContactError(i18n.t("newTicketModal.errors.contactRequired") || "Debe seleccionar un contacto para crear el ticket");
      hasErrors = true;
    }
    
    // ✅ VALIDACIÓN 2: Conexión es OBLIGATORIA siempre
    if (selectedWhatsapp === "") {
      setWhatsappError(i18n.t("newTicketModal.errors.connectionRequired") || "Debe seleccionar una conexión");
      hasErrors = true;
    }

    // Departamento opcional: el usuario decide según permisos / flujo; queueId null si no elige.

    // ✅ Si hay errores de validación, no continuar
    if (hasErrors) {
      return;
    }
    
    setLoading(true);
    try {
      const queueId = selectedQueue !== "" ? selectedQueue : null;
      const whatsappId = selectedWhatsapp !== "" ? selectedWhatsapp : null;
      const { data: ticket } = await createTicket({
        contactId: contactId,
        queueId,
        whatsappId,
        userId: user.id,
        status: "open",
        confirmUpdate: confirmUpdate
      });      

      setLoading(false);
      setConfirmUpdateOpen(false);
      setExistingTicket(null);
      setPendingTicketData(null);
      onClose(ticket);
    } catch (err) {
      setLoading(false);
      
      // ✅ Manejo correcto de errores: usar toastError para mostrar mensaje traducido
      const errorCode = err.response?.data?.error;
      
      // ✅ Si necesita confirmación, mostrar modal de confirmación
      if (errorCode === "ERR_TICKET_NEEDS_CONFIRMATION") {
        const queueId = selectedQueue !== "" ? selectedQueue : null;
        const whatsappId = selectedWhatsapp !== "" ? selectedWhatsapp : null;
        setExistingTicket(err.response?.data?.ticket);
        setPendingTicketData({ contactId, queueId, whatsappId });
        setConfirmUpdateOpen(true);
        return;
      }
      
      // ✅ Si es ERR_OTHER_OPEN_TICKET, mostrar en modal
      if (errorCode === "ERR_OTHER_OPEN_TICKET") {
        const errorMsg = err.response?.data?.message || i18n.t("backendErrors.ERR_OTHER_OPEN_TICKET");
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
        return;
      }
      
      // ✅ Si es ERR_TICKET_EXISTS_WITH_DIFFERENT_QUEUE, mostrar en modal con nombre del departamento
      if (errorCode === "ERR_TICKET_EXISTS_WITH_DIFFERENT_QUEUE") {
        // ✅ Extraer queueName de la respuesta del backend
        const queueName = err.response?.data?.queueName || "Departamento desconocido";
        
        // ✅ Construir mensaje con nombre del departamento
        const baseMessage = i18n.t("backendErrors.ERR_TICKET_EXISTS_WITH_DIFFERENT_QUEUE");
        // ✅ Reemplazar el placeholder {{queueName}} con el nombre real
        let errorMsg = baseMessage;
        if (baseMessage.includes("{{queueName}}")) {
          errorMsg = baseMessage.replace(/\{\{queueName\}\}/g, queueName);
        } else {
          // ✅ Si no tiene placeholder, construir mensaje manualmente
          errorMsg = `Ya existe un ticket abierto con el departamento ${queueName}.`;
        }
        
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
        return;
      }
      
      // ✅ Si es ERR_TICKET_EXISTS_WITH_QUEUE, mostrar en modal
      if (errorCode === "ERR_TICKET_EXISTS_WITH_QUEUE") {
        const errorMsg = err.response?.data?.message || i18n.t("backendErrors.ERR_TICKET_EXISTS_WITH_QUEUE");
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
        return;
      }
      
      // ✅ Para otros errores, mostrar en modal
      const errorMsg = err.response?.data?.message || err.response?.data?.error || "Error al crear el ticket";
      setErrorMessage(errorMsg);
      setErrorModalOpen(true);
    }
  };

  const handleConfirmUpdate = () => {
    if (pendingTicketData) {
      handleSaveTicket(pendingTicketData.contactId, true);
    }
  };

  const handleCancelUpdate = () => {
    setConfirmUpdateOpen(false);
    setExistingTicket(null);
    setPendingTicketData(null);
  };

  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setContactModalOpen(false);    
  };

  const handleAddNewContactTicket = contact => {
    handleSaveTicket(contact.id);
  };

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== "" && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };

  const renderOption = option => {
    if (option.number) {
      return <>
        {/* {IconChannel(option.channel)} */}
        <Typography component="span" style={{ fontSize: 14, marginLeft: "10px", display: "inline-flex", alignItems: "center", lineHeight: "2" }}>
          {option.name} - {option.number}
        </Typography>
      </>
    } else {
      return `${i18n.t("newTicketModal.add")} ${option.name}`;
    }
  };

  const renderOptionLabel = option => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };

  const renderContactAutocomplete = () => {
    if (initialContact === undefined || initialContact.id === undefined) {
      return (
        <Grid xs={12} item>
          <Autocomplete
            fullWidth
            options={options}
            loading={loading}
            clearOnBlur
            autoHighlight
            freeSolo
            clearOnEscape
            getOptionLabel={renderOptionLabel}
            renderOption={renderOption}
            filterOptions={createAddContactOption}
            onChange={(e, newValue) => {
              handleSelectOption(e, newValue);
              // ✅ Limpiar error cuando el usuario selecciona un contacto
              if (contactError && newValue?.number) {
                setContactError("");
              }
            }}
            renderInput={params => (
              <TextField
                {...params}
                label={i18n.t("newTicketModal.fieldLabel")}
                variant="outlined"
                autoFocus
                error={!!contactError}
                helperText={contactError || ""}
                onChange={e => {
                  setSearchParam(e.target.value);
                  // ✅ Limpiar error cuando el usuario empieza a escribir
                  if (contactError) {
                    setContactError("");
                  }
                }}
                onKeyPress={e => {
                  if (loading || !selectedContact) return;
                  else if (e.key === "Enter") {
                    handleSaveTicket(selectedContact.id);
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      )
    }
    return null;
  }

  return (
    <>
      <ContactModal
        open={contactModalOpen}
        initialValues={newContact}
        onClose={handleCloseContactModal}
        onSave={handleAddNewContactTicket}
      ></ContactModal>
      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">
          {i18n.t("newTicketModal.title")}
        </DialogTitle>
        <DialogContent dividers>
          <Grid style={{ width: 300 }} container spacing={2}>
            {/* CONTATO */}
            {renderContactAutocomplete()}
            {/* FILA */}
            <Grid xs={12} item>
              <Select
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedQueue}
                error={!!queueError}
                onChange={(e) => {
                  setSelectedQueue(e.target.value);
                  // ✅ Limpiar error cuando el usuario selecciona un valor
                  if (queueError) {
                    setQueueError("");
                  }
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedQueue === "") {
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                        <span style={{ marginRight: '8px' }} role="img" aria-label="Departamento">🏢</span>
                        <span>{i18n.t("newTicketModal.selectQueue")}</span>
                      </div>
                    )
                  }
                  // ✅ Usar queues cargadas desde API o fallback a user.queues
                  const availableQueues = queues.length > 0 ? queues : (user.queues || []);
                  const queue = availableQueues.find(q => q.id === selectedQueue);
                  if (!queue) {
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                        <span style={{ marginRight: '8px' }} role="img" aria-label="Departamento">🏢</span>
                        <span>{i18n.t("newTicketModal.selectQueue")}</span>
                      </div>
                    );
                  }
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: '8px' }} role="img" aria-label="Departamento">🏢</span>
                      <span>{queue.name}</span>
                    </div>
                  )
                }}
              >
                {(() => {
                  // ✅ Usar queues cargadas desde API o fallback a user.queues
                  const availableQueues = queues.length > 0 ? queues : (user.queues || []);
                  return availableQueues.length > 0 && availableQueues.map((queue, key) => (
                    <MenuItem dense key={key} value={queue.id}>
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="Departamento">🏢</span>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {queue.name}
                          </span>
                          <span style={{ fontSize: '12px', color: '#666' }}>
                            {i18n.t("newTicketModal.departmentAttention")}
                          </span>
                        </div>
                      </div>
                    </MenuItem>
                  ));
                  })()}
              </Select>
              {/* ✅ Mensaje de error debajo del campo de departamento */}
              {queueError && (
                <Typography variant="caption" color="error" style={{ marginTop: '4px', marginLeft: '14px', display: 'block' }}>
                  {queueError}
                </Typography>
              )}
            </Grid>
            {/* CONEXAO */}
            <Grid xs={12} item>
              <Select
                required
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectedWhatsapp}
                error={!!whatsappError}
                onChange={(e) => {
                  setSelectedWhatsapp(e.target.value);
                  // ✅ Limpiar error cuando el usuario selecciona un valor
                  if (whatsappError) {
                    setWhatsappError("");
                  }
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === "") {
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', color: '#999' }}>
                        <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                        <span>{i18n.t("newTicketModal.selectConnection")}</span>
                      </div>
                    )
                  }
                  const whatsapp = whatsapps.find(w => w.id === selectedWhatsapp)
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: '8px' }} role="img" aria-label="WhatsApp">📱</span>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {whatsapp.name || `Conexión ${whatsapp.id}`}
                        </span>
                        <span style={{ fontSize: '12px', color: '#666' }}>
                          {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                           whatsapp.name ? whatsapp.name : 
                           `Conexión ${whatsapp.id}`}
                        </span>
                      </div>
                    </div>
                  )
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <span style={{ marginRight: '8px', fontSize: '16px' }} role="img" aria-label="WhatsApp">📱</span>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                              {whatsapp.name || `Conexión ${whatsapp.id}`}
                            </span>
                            <span 
                              style={{ 
                                fontSize: '10px', 
                                padding: '2px 6px', 
                                borderRadius: '10px',
                                backgroundColor: whatsapp.status === 'CONNECTED' ? '#25d366' : '#e1306c',
                                color: 'white',
                                fontWeight: 'bold'
                              }}
                            >
                              {whatsapp.status}
                            </span>
                          </div>
                          <span style={{ fontSize: '12px', color: '#666' }}>
                            {whatsapp.waName ? `${whatsapp.name} - ${whatsapp.waName}` : 
                             whatsapp.name ? whatsapp.name : 
                             `Conexión ${whatsapp.id}`}
                          </span>
                        </div>
                      </div>
                    </MenuItem>
                  ))}
              </Select>
              {/* ✅ Mensaje de error debajo del campo de conexión */}
              {whatsappError && (
                <Typography variant="caption" color="error" style={{ marginTop: '4px', marginLeft: '14px', display: 'block' }}>
                  {whatsappError}
                </Typography>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            disabled={loading}
            variant="outlined"
          >
            {i18n.t("newTicketModal.buttons.cancel")}
          </Button>
          <ButtonWithSpinner
            variant="contained"
            type="button"
            disabled={!selectedContact}
            onClick={() => handleSaveTicket(selectedContact.id)}
            color="primary"
            loading={loading}
          >
            {i18n.t("newTicketModal.buttons.ok")}
          </ButtonWithSpinner>
        </DialogActions>

      </Dialog>
      
      {/* ✅ MODAL DE CONFIRMACIÓN PARA ACTUALIZAR TICKET EXISTENTE */}
      <ConfirmationModal
        title="Actualizar Ticket Existente"
        open={confirmUpdateOpen}
        onClose={handleCancelUpdate}
        onConfirm={handleConfirmUpdate}
      >
        {i18n.t("backendErrors.ERR_TICKET_NEEDS_CONFIRMATION")}
      </ConfirmationModal>
      
      {/* ✅ MODAL DE ERROR PARA MOSTRAR MENSAJES DE ERROR */}
      <ConfirmationModal
        title="Error"
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        onConfirm={() => setErrorModalOpen(false)}
        showCancel={false}
        confirmText="Cerrar"
      >
        {errorMessage}
      </ConfirmationModal>
    </>
  );
};
export default NewTicketModal;